import { connect } from 'react-redux'
import { toggleFullscreenOverlay, pageToggleOverlay } from 'redux/actions'
import DealDetails from 'pages/mwdealdetails/Main'

const mapDispatchToProps = dispatch => ({
  toggleFullscreenOverlay: fullScreenOverlay => dispatch(toggleFullscreenOverlay(fullScreenOverlay)),
  pageToggleOverlay: (component) => dispatch(pageToggleOverlay(component))
})

export default connect(null, mapDispatchToProps)(DealDetails)
